import styled from "styled-components";
import * as common from "../../common";

export const mainCurrencyPage = styled(common.flexColumn)``;
export const mainCurrencyRates = styled(common.flexColumn)`
  width: 100%;
`;
export const currencySelection = styled(common.flexRow)``;
